import { RelationRole, RelationRoleType } from "../contracts/base";

export class RelationRoleMapper {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    static mapToEnumValue(value: RelationRoleType | string): RelationRole {
        if (value.toLowerCase() === "parent") {
            return RelationRole.Parent;
        } else if (value.toLowerCase() === "child") {
            return RelationRole.Child;
        } else {
            throw Error(`Can't map '${value}' to enum value.`);
        }
    }

    static mapToType(value: RelationRole | string): RelationRoleType {
        if (value === RelationRole.Parent || value === RelationRole[RelationRole.Parent]) {
            return "Parent";
        } else if (value === RelationRole.Child || value === RelationRole[RelationRole.Child]) {
            return "Child";
        } else {
            throw Error(`Can't map '${value} to type.`);
        }
    }
}
